import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { useMemo } from 'react';
import { isRelativeUrl } from '../utils/url';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const getSanitizedReturnLink = rawReturnLink => {
  if (rawReturnLink === undefined) {
    return undefined;
  }
  const portalId = PortalIdParser.get();
  const defaultLink = `/contacts/${portalId}/objects/0-1/views/all/list`;
  return rawReturnLink && isRelativeUrl(rawReturnLink) ? rawReturnLink : defaultLink;
};
export const AllViewsLink = ({
  returnLink,
  namespace,
  objectTypeId
}) => {
  const portalId = PortalIdParser.get();
  const urlSearchParams = useMemo(() => {
    const params = new URLSearchParams();
    params.append('namespace', namespace);
    params.append('objectTypeId', objectTypeId);
    const sanitizedReturnLink = getSanitizedReturnLink(returnLink);
    if (sanitizedReturnLink !== undefined) {
      params.append('returnLink', sanitizedReturnLink);
    }
    return params;
  }, [namespace, objectTypeId, returnLink]);
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "all-views-button",
    use: "link",
    href: `/manage-views/${portalId}/all?${urlSearchParams.toString()}`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.pinnedViews.allViews"
    })
  });
};